import styled from 'styled-components';

export const ResultStyle = styled.div`
  input {
    width: 100%;
    padding: 10px;
    height: 38px;
    display: inline-block;
    background: var(--bg);
    border-radius: 2px;
    border: 1px solid var(--gray900);
  }

  .gradeExamYearType {
    display: flex;
    justify-content: space-between;
  }

  .markList {
    width: 70%;
    margin-top: 30px;
  }

  .studentMarks {
    display: flex;
    justify-content: space-between;
    margin: 10px 0px 10px 0px;
  }

  .students,
  .marks {
    font-size: var(--font-base);
    font-weight: 700;
    // margin-Right: 50px;
    // margin-Left: 50px;
  }
  .studentName {
    font-size: var(--font-base);
    font-weight: 500;
    // margin-left: 10px;
  }
  .studentObtainedMarks {
    font-size: var(--font-base);
    font-weight: 500;
    // margin-right: 10px;
  }

  button {
    margin-top: 20px;
    background: var(--primary);
    border-radius: 4px;
    color: var(--white);
    font-weight: 700;
    width: 213px;
    height: 40px;
    border: none;
    font-size: var(--font-base);
    :hover {
      box-shadow: var(--shadow-base);
      background: var(--grey);
      color: var(--white);
    }
  }

  .dropDownButton {
    width: 100%;
    padding: 10px;
    borderradius: 4px;
    border: 1px solid var(--gray900);
    background: var(--white);
    color: var(--black);
    text-align: left;
    display: flex;
    justify-content: space-between;
    margin: 0px;
    font-weight: none;
    font-size: var(--font-sm);
    :hover {
      background: none;
      color: var(--black);
    }
  }
`;
